<div>
  <div *ngFor="let tableSection of tableSections" class="CommonTable OATable">
    <div id="{{ tableSection.heading }}" [innerHTML]="tableSection.body | mdToHtml"></div>
    <div class="body-table AutoWidthTable" *ngIf="tableSection.table" [innerHtml]="returnHtmlFromRichText(tableSection.table) | mdToHtml"></div>
  </div>
</div>
